import en from '@/locales/en'
import it from '@/locales/it'
import de from '@/locales/de'

// Funzione per ottenere la lingua del browser
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage
  const langCode = browserLang.split('-')[0] // es: 'it-IT' -> 'it'
  const supportedLanguages = ['en', 'it', 'de']
  return supportedLanguages.includes(langCode) ? langCode : 'en'
}

const state = {
  currentLanguage: localStorage.getItem('language') || getBrowserLanguage(),
  translations: {
    en,
    it,
    de
  }
}

const mutations = {
  SET_LANGUAGE(state, language) {
    state.currentLanguage = language
    // Salva la lingua in localStorage per persistenza tra le sessioni
    localStorage.setItem('language', language)
  }
}

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

const getters = {
  currentLanguage: state => state.currentLanguage,
  translations: state => state.translations[state.currentLanguage]
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 